import { Dic } from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const tableOption = function (staffShow, operateShow) {
  if (staffShow) {
    // 员工信息
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      page: true,
      selection: true,
      index: false,
      indexLabel: '序号',
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: '：',
      size: 'small',
      maxHeight: '100%',
      labelWidth: '140px',
      menuAlign: 'center',
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 400,
      dialogWidth: '700px',
      emptyText: i18n.t('personAccess.title.noData'),
      menu: false,
      column: [
        {
          label: '姓名',
          prop: 'name',
          addDisplay: true,
          editDisplay: true,
          overHidden: true,
          search: true,
          searchPlaceholder: '请输入姓名',
          span: 12
        },
        {
          label: '电话',
          prop: 'phone',
          search: true,
          searchPlaceholder: '请输入电话',
          span: 12
        },
        {
          label: '工号',
          prop: 'workNo',
          search: true,
          span: 12
        },
        {
          label: '部门',
          prop: 'departmentName',
          search: false,
          span: 12
        },
        // {
        //   label: '岗位',
        //   prop: 'positionName',
        //   search: false,
        //   span: 12
        // },
        // {
        //   label: '员工类型',
        //   prop: 'personnelMark',
        //   search: false,
        //   span: 12
        // },
        {
          label: '性别',
          prop: 'sex',
          addDisplay: true,
          editDisplay: true,
          overHidden: true,
          search: false,
          hide: true,
          span: 12,
          dicData: Dic.find('SENU092'),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue('SENU092', Number(value))
            }
            return ''
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue('SENU092', value) : ''
          }
        },

        // {
        //     label: '是否在职',
        //     prop: 'status',
        //     viewslot: true,
        //     type: 'select',
        //     search: true,
        //     span: 12,
        //     dicData: [{
        //             label: '全部',
        //             value: -1,
        //         },
        //         {
        //             label: '在职',
        //             value: 1,
        //         },
        //         {
        //             label: '离职',
        //             value: 2,
        //         },
        //         {
        //             label: '未知',
        //             value: 4,
        //         },
        //     ],
        //     formatter: function (row, value) {
        //         let str = ''
        //         if (value == -1) {
        //             str = '全部'
        //         }
        //         if (value == 1) {
        //             str = '在职'
        //         }
        //         if (value == 2) {
        //             str = '离职'
        //         }
        //         if (value == 4) {
        //             str = '未知'
        //         }
        //         return str
        //     },
        //     viewFormatter: function (row, value) {
        //         let str = ''
        //         if (value == -1) {
        //             str = '全部'
        //         }
        //         if (value == 1) {
        //             str = '在职'
        //         }
        //         if (value == 2) {
        //             str = '离职'
        //         }
        //         if (value == 4) {
        //             str = '未知'
        //         }
        //         return str
        //     },
        // },
        {
          label: '照片',
          prop: 'img',
          width: 100,
          align: 'center',
          formatter: function (row, value) {
            let srt = ''
            return value
              ? '/common/file/downLoadFileStream.json?fileCode=' + value
              : ''
          }
        }
      ]
    }
  } else {
    // 外来临员
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      page: true,
      selection: true,
      index: false,
      indexLabel: '序号',
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: '：',
      size: 'small',
      maxHeight: '100%',
      labelWidth: '140px',
      menuAlign: 'center',
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 200,
      dialogWidth: '450px',
      emptyText: i18n.t('personAccess.title.noData'),
      menu: true,
      column: [
        {
          label: '姓名',
          prop: 'name',
          addDisplay: true,
          editDisplay: true,
          // viewDisplay: false,
          overHidden: true,
          search: true,
          searchPlaceholder: '请输入姓名',
          span: 12
        },
        {
          label: '性别',
          prop: 'sex',
          addDisplay: true,
          editDisplay: true,
          // viewDisplay: false,
          overHidden: true,
          search: false,
          searchPlaceholder: '请选择',
          span: 12,
          dicData: Dic.find('SENU092'),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue('SENU092', Number(value))
            }
            return ''
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue('SENU092', value) : ''
          }
        },
        {
          label: '电话',
          // align: 'center',
          prop: 'phone',
          search: true,
          searchPlaceholder: '请输入电话',
          span: 12,
          select: true
        },
        {
          label: '外来人员类型',
          // align: 'center',
          prop: 'visitorTypeName',
          span: 12,
          type: 'select',
          multiple: true
        },
        {
          label: '证件号码',
          // align: 'center',
          prop: 'idCard',
          search: false,
          searchPlaceholder: '请输入',
          span: 12
        },

        {
          label: '上次来访时间',
          prop: 'lastTrafficTime',
          overHidden: true,
          addDisplay: true,
          editDisplay: true,
          viewDisplay: false,
          hide: true,
          type: 'datetime',
          span: 24,
          formatter: function (row, value) {
            return value
              ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss')
              : ''
          }
        },
        {
          label: '来访接待人',
          // align: 'center',
          prop: 'receiverName',
          search: false,
          searchPlaceholder: '请输入',
          span: 12,
          hide: true
        },
        {
          label: '录入时间',
          prop: 'modifyTime',
          hide: true,
          search: false,
          span: 12
        },
        {
          label: '照片',
          prop: 'img',
          viewDisplay: true,
          viewslot: true,
          width: 100,
          align: 'center',
          formatter: function (row, value) {
            let srt = ''
            console.log('pic', value)
            return value
              ? '/common/file/downLoadFileStream.json?fileCode=' + value
              : ''
          }
        }
      ]
    }
  }
}
export default tableOption
